'use client';
'use strict';

var React = require('react');
var Portal = require('./Portal.cjs');

function OptionalPortal({ withinPortal = true, children, ...others }) {
  if (withinPortal) {
    return /* @__PURE__ */ React.createElement(Portal.Portal, { ...others }, children);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
}
OptionalPortal.displayName = "@mantine/core/OptionalPortal";

exports.OptionalPortal = OptionalPortal;
//# sourceMappingURL=OptionalPortal.cjs.map
